import React, { useState } from 'react';
import axios from 'axios';

function Comment({ comment, documentId, isRoot }) {
  const [replyText, setReplyText] = useState('');
  // Ensure replies is never undefined by using an empty array as default
  const [replies, setReplies] = useState(comment.replies || []);
  const [replyButton, setReplyButton] = useState(false);

  // const addReply = () => {
  //   axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${comment._id}/reply`, {
  //     text: replyText,
  //     commenter: 'Anonymous' // Replace with user session data if available
  //   })
  //   .then(response => {
  //     // Check if response.data.replies is undefined and default to empty array
  //     setReplies(response.data.replies || []);
  //     setReplyText('');
  //   })
  //   .catch(error => console.error('Error adding reply:', error));
  // };

  const toggleReply = () => {
    setReplyButton(!replyButton);
  };

  const addReply = () => {
    axios.post(`https://api.finaloffers.fyi/jobOffers/view/${documentId}/comments/${comment._id}/reply`, {
      text: replyText,
      commenter: 'Anonymous'
    })
    .then(response => {
      // Assuming response.data is the updated comment with new replies
      setReplies(response.data.replies);
      setReplyText('');
      setReplyButton(!replyButton);
    })
    .catch(error => console.error('Error adding reply:', error));
  };
  

  return (
    <div className={`${isRoot ? 'ml-0' : 'ml-[20px]'}`}>
      <div className='inline-flex mb-2 gap-x-2'>
        <div className='font-bold text-lg mt-1'>{comment.commenter}</div>
        <div className='text-sm mt-2'>{new Date(comment.timestamp).toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          hour12: true // Use 12-hour time format
        })}</div>
      </div>
      <div className=''>
        <p >{comment.text}</p>
      </div>

      {/* <textarea
        value={newComment}
        onChange={e => setNewComment(e.target.value)}
        placeholder="Write a comment..."
        className='w-full mt-4 rounded py-1 bg-white focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px] overflow-y-auto resize-none'
        rows="1"
      />
      <button onClick={addComment} className='mt-2 rounded bg-black text-white py-1 px-3 text-sm'>Add Comment</button> */}
      {replyButton ? (
        <div>
          <textarea
            type="text"
            value={replyText}
            onChange={e => setReplyText(e.target.value)}
            placeholder="Reply to this comment..."
            className='w-full mt-4 rounded py-1 bg-white text-sm focus:ring-[#cfcfb4] focus:ring-offset focus:ring-[3px] overflow-y-auto resize-none'
            rows="1"
          />
          <button onClick={toggleReply} className='mt-2 rounded border border-black py-1 px-3 text-sm mr-2'>Cancel</button>
          <button onClick={addReply} className='mt-2 rounded bg-black text-white py-1 px-3 text-sm'>Add Reply</button>
        </div>
      ) : (
        <button onClick={toggleReply}>
          <div className='inline-flex gap-x-1 text-stone-400 my-2 border-b border-transparent hover:border-black'>
            <div className='h-1 w-2 my-1 mr-1 text-xs'>
            <i className="fa-solid fa-reply"></i>
            </div>
            
            Reply
          </div>
        </button>
      )}
      
      
      {replies.length > 0 && replies.map(reply => (
        <Comment key={reply._id} comment={reply} documentId={documentId} isRoot={false} />
      ))}
    </div>
  );
}

export default Comment;

// import React, { useState } from 'react';
// import axios from 'axios';

// function Comment({ comment, documentId }) {
//   const [replyText, setReplyText] = useState('');
//   // Ensure replies is never undefined by using an empty array as default
//   const [replies, setReplies] = useState(comment.replies || []);

//   const addReply = () => {
//     axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${comment._id}/reply`, {
//       text: replyText,
//       commenter: 'Anonymous' // Replace with user session data if available
//     })
//     .then(response => {
//       // Check if response.data.replies is undefined and default to empty array
//       setReplies(response.data.replies || []);
//       setReplyText('');
//     })
//     .catch(error => console.error('Error adding reply:', error));
//   };

//   return (
//     <div style={{ marginLeft: '20px' }}>
//       <p>{comment.text} - by {comment.commenter}</p>
//       <input
//         type="text"
//         value={replyText}
//         onChange={e => setReplyText(e.target.value)}
//         placeholder="Reply to this comment..."
//       />
//       <button onClick={addReply}>Reply</button>
      
//       {replies.length > 0 && replies.map(reply => (
//         <Comment key={reply._id} comment={reply} documentId={documentId} />
//       ))}
//     </div>
//   );
// }

// export default Comment;

// import React, { useState } from 'react';
// import axios from 'axios';

// function Comment({ comment, documentId }) {
//   const [replyText, setReplyText] = useState('');
//   const [replies, setReplies] = useState(comment.replies || []);

//   // const addReply = () => {
//   //   axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${comment._id}/reply`, {
//   //     text: replyText,
//   //     commenter: 'Anonymous' // Replace with user session data if available
//   //   })
//   //     .then(response => {
//   //       setReplies([...replies, response.data]);
//   //       setReplyText('');
//   //     })
//   //     .catch(error => console.error('Error adding reply:', error));
//   // };

//   const addReply = () => {
//     axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${comment._id}/reply`, {
//       text: replyText,
//       commenter: 'Anonymous'
//     })
//     .then(response => {
//       // Assuming response.data includes the updated comment with new replies
//       setReplies(response.data.replies);
//       setReplyText('');
//     })
//     .catch(error => console.error('Error adding reply:', error));
//   };
  

//   return (
//     <div style={{ marginLeft: '20px' }}>
//       <p>{comment.text} - by {comment.commenter}</p>
//       <input
//         type="text"
//         value={replyText}
//         onChange={e => setReplyText(e.target.value)}
//         placeholder="Reply to this comment..."
//       />
//       <button onClick={addReply}>Reply</button>
      
//       {replies.length > 0 && replies.map(reply => (
        
//         <Comment key={reply._id} comment={reply} documentId={documentId} />
        
//       ))}
//     </div>
//   );
// }

// export default Comment;

// import React, { useState } from 'react';
// import axios from 'axios';

// function Comment({ comment, documentId }) {
//   const [replyText, setReplyText] = useState('');
//   const [replies, setReplies] = useState(comment.replies || []);
//   const [jobOffer, setJobOffer] = useState(null);

//   const addReply = () => {
//     axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${comment._id}/reply`, { text: replyText, commenter: 'Anonymous' })
//       .then(response => {
//         setReplies([...replies, response.data]);
//         setReplyText('');
//       })
//       .catch(error => console.error('Error adding reply:', error));
//   };

//     const handleVote = (commentId, type) => {
//     axios.post(`http://localhost:5000/jobOffers/view/${documentId}/comments/${commentId}/${type}`)
//       .then(response => {
//         setJobOffer(response.data); // Update the job offer with the new votes
//       })
//       .catch(error => console.error(`Error ${type}voting comment:`, error));
//   };

//   return (
//     <div style={{ marginLeft: '20px' }}>
//       <p>{comment.text} - by {comment.commenter}</p>
//                 {/* <p>{comment.text} - by {comment.commenter}</p> */}
//                 <button onClick={() => handleVote(comment._id, 'upvote')}>Upvote ({comment.upvotes})</button>
//                 {/* {comment.upvotes - comment.downvotes} */}
//                 <button onClick={() => handleVote(comment._id, 'downvote')}>Downvote ({comment.downvotes})</button>
//                 <p>Effective Votes: {comment.netVotes}</p>
//       <div>
//         {replies.map(reply => (
//           <Comment key={reply._id} comment={reply} documentId={documentId} />
//         ))}
//       </div>
//       <input
//         type="text"
//         value={replyText}
//         onChange={e => setReplyText(e.target.value)}
//         placeholder="Reply to this comment..."
//       />
//       <button onClick={addReply}>Reply</button>
//     </div>
//   );
// }

// export default Comment;
